import { axiosApi } from '../globals';

export namespace user {
  export const get = (id: string) => {
    return axiosApi.run('get', '/User/Single');
  };

  export const patch = (change: PatchChange) => {
    return axiosApi.run('patch', '/User/Update', {
      ...change,
    });
  };

  export const getApi = () => {
    return axiosApi.run('get', '/User/getApiClientIdSecret');
  };

  export const createPaddleCustomerPortal = () => {
    return axiosApi.run('post', '/User/createPaddleCustomerPortal');
  };

  export const rotateApi = () => {
    return axiosApi.run('post', '/User/rotateClientSecret');
  };

  export const deductCreditsForExport = () => {
    return axiosApi.run('post', '/User/deductCreditsForExport');
  };

  export const canExport = () => {
    return axiosApi.run('get', '/User/canExport');
  };

  export const getSettings = () => {
    return axiosApi.run('get', '/v2/settings');
  };

  export const patchSettings = (change: Json) => {
    return axiosApi.run('patch', '/v2/settings', { settings: change });
  };
}

type PatchChange = {
  isAlpha: boolean;
};
